import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { StepSharingSettingsProps } from '../types';
import { SharingControls } from '../../../ui/SharingControls';

/**
 * Step 3: Sharing settings wrapper
 * Integrates SharingControls component
 */
export const StepSharingSettings: React.FC<StepSharingSettingsProps> = ({
  sharingData,
  onChange,
  mode,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t('shareFolder.sharingDescription')}
      </Typography>

      <SharingControls
        data={sharingData}
        onChange={onChange}
        showPurpose={false}
        showRoles={false}
      />
    </>
  );
};
